/* eslint-disable import-x/exports-last */
import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';
import type {ReccoRecommendationDTO} from '@/ts/types/dto/recco/recommendation.dto';
import type {BadgeDTO} from '@/ts/types/dto/badge-dto';

/**
 * A tag-matched challenge recommendation (excludes already-started challenges). Up to 3 are
 * mixed into the Explore "For you" rail (IPD-2836 product decision: "max 3, mixed in").
 */
export interface ChallengeRecommendationDTO {
  id: number,
  title: string,
  description: string,
  imageUrl: string,
  taskCount: number,
}

/** Full challenge details including progress, sessions, badge, and participation dates */
export interface ChallengeDTO {
  id: number;
  headline: string;
  descriptionHTML: string;
  goal: string;
  userChallengeId: string;
  state: ReccoChallengeStateDTO | null;
  joinedDate: string;
  completedDate: string;
  stats: any;
  author: any;
  badge: BadgeDTO | null;
  duration: number;
  pctCompletionProgress: number;
  pendingStateAcknowledgment: boolean;
  sessions: ChallengeSessionDTO[];
  imageUrl: string;
};

/** A time-gated session within a challenge, containing tasks and unlock scheduling */
export interface ChallengeSessionDTO {
  id: number;
  userSessionId: UuidDTO;
  name: string;
  description: string;
  state: ReccoChallengeSessionStateDTO;
  completedDate: string;
  minOptionalTasks: number;
  pctCompletionProgress: number;
  tasks: ChallengeTaskDTO[];
  unlockDate: string;
  timeUntilUnlockMillis: number;
}

/** An individual task within a challenge session, linking to a recommendation */
export interface ChallengeTaskDTO {
  userTaskId: UuidDTO,
  recommendation: ReccoRecommendationDTO,
  state: ReccoChallengeSessionStateDTO,
  completedDate: string,
  isOptional: true
}

/** Lifecycle states of a Recco challenge */
export enum ReccoChallengeStateDTO {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  WITHDREW = 'WITHDREW',
  NOT_JOINED = 'NOT_JOINED',
}

/** Lifecycle states of an individual session within a Recco challenge */
export enum ReccoChallengeSessionStateDTO {
  LOCKED = 'LOCKED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}